module.exports = __webpack_public_path__ + "static/media/MOLDURA_PES_ISTAMBUL_2023_03-ESMA_SULTAN.d9934e1e.png";